/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SandboxFeature = {
  Python: "python",
  Git: "git",
  ClaudeCode: "claude-code",
} as const;
export type SandboxFeature = ClosedEnum<typeof SandboxFeature>;

/** @internal */
export const SandboxFeature$inboundSchema: z.ZodNativeEnum<
  typeof SandboxFeature
> = z.nativeEnum(SandboxFeature);
/** @internal */
export const SandboxFeature$outboundSchema: z.ZodNativeEnum<
  typeof SandboxFeature
> = SandboxFeature$inboundSchema;
